import { AppProvider } from './store/store';
import Routing from './routes/Routing';

function App() {
  return (
    <AppProvider>
      <Routing />
    </AppProvider>
  );
}
export default App;
